import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IUser, IUserState, LoginType } from './interfaces';
import api from '../../lib/api';
import useCookie from '../../lib/hooks/useCookie';
import { AUTH_TOKEN } from '../../lib/constans';
import { AppState, AppThunk } from '..';

const initialState: IUserState = {
  user: null,
  isLoading: false,
  error: '',
};

// export const login = createAsyncThunk('user/login', async (arg: LoginType, thunkApi) => {
//   const navigate = useNavigate();
//   try {
//     const { setCookie } = useCookie();
//     const response = await api.user.login(arg);
//     const { firstName, lastName, token, email } = response;
//     setCookie(TOKEN, token);
//     // navigate('/');
//     return { firstName, lastName, token, email };
//   } catch (e) {
//     return thunkApi.rejectWithValue('login error!');
//   }
// });

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, { payload }: PayloadAction<IUser | null>) => {
      state.user = payload;
    },
  },
});

export const login =
  (params: LoginType): AppThunk =>
  async dispatch => {
    try {
      const { setCookie } = useCookie();
      const response = await api.user.login(params);
      const { firstName, lastName, token, email } = response;
      dispatch(setUser({ firstName, lastName, token, email }));
      setCookie(AUTH_TOKEN, token);
      return 200;
    } catch (e) {
      return e.response.status;
    }
  };

export const logout = () => dispatch => {
  dispatch(setUser(null));
};

export const { setUser } = userSlice.actions;

export const selectAuthState = (state: AppState) => state.userReducer;

export default userSlice.reducer;
